import moment from "moment";
import React, { useMemo } from "react";
import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import styled from "styled-components";

const PieContainer = styled.div``;

const LegendWrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  padding-bottom: 30px;
  width: 320px;
  margin-left: 46px;
`;

const LegendItemWrapper = styled.div`
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-items: "self-end";
  margin-top: 15px;
`;

const LegendTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 600;
  margin-right: 5px;
`;

const LegendDot = styled.div`
  background-color: ${(props) => props.color ?? "#000"};
  height: 14px;
  width: 14px;
  border-radius: 7px;
  margin-right: 5px;
`;

const LegendValue = styled.span`
  color: ${(props) => (props.empty ? "red" : "#000")};
  margin-left: 20px;
`;

const CustomTooltipContainer = styled.div`
  background-color: #fff;
  margin: 0;
  padding: 10px;
  border: 1px solid rgb(204, 204, 204);
  white-space: nowrap;
`;

const CustomTooltip = (props) => {
  const { active, payload } = props;

  if (active && payload && payload.length) {
    return (
      <CustomTooltipContainer>
        <p>{payload[0].payload.letter}</p>
        <p>{payload[0].payload.info}</p>
        <p>{payload[0].payload.subInfo}</p>
      </CustomTooltipContainer>
    );
  }

  return null;
};

const CustomLegend = (props) => {
  const { payload } = props;

  const emptyValues = useMemo(
    () =>
      payload
        .filter((entry) => entry.payload.isVisible)
        .every((entry) => entry.payload.frequency === 0),
    [payload]
  );

  return (
    <LegendWrapper>
      {payload
        ?.filter((entry) => entry.payload.isVisible)
        .map((entry, index) => (
          <LegendItemWrapper key={`item-${index}`}>
            <LegendTitleWrapper>
              <LegendDot color={entry.color} />
              <span>{entry.value}</span>
            </LegendTitleWrapper>

            {entry.payload.info && (
              <LegendValue empty={emptyValues}>
                {entry.payload.info}
              </LegendValue>
            )}
            {entry.payload.subInfo && <span>{entry.payload.subInfo}</span>}
          </LegendItemWrapper>
        ))}
    </LegendWrapper>
  );
};

const CustomPieChart = (props) => {
  const { series, width, height, customKey = "pie-chart" } = props;

  return (
    <PieContainer key={customKey} data-testid="pie-chart" className="pie-chart">
      <PieChart key={moment().toISOString()} width={width} height={height + 20}>
        <Pie
          isAnimationActive={false}
          data={series}
          nameKey="letter"
          dataKey="frequency"
        >
          {series.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
        <Tooltip separator="" content={<CustomTooltip />} />
        <Legend
          verticalAlign="bottom"
          align="left"
          iconType="circle"
          content={<CustomLegend />}
        />
      </PieChart>
    </PieContainer>
  );
};

export default CustomPieChart;
